import * as model from "./model";

const surfaceDefaultsDefaultRecord = () => ({
    [model.PROPS_ACTIVE_YN]: true,
    [model.PROPS_CLASSIFICATION_METHOD_GUID]: "",
    [model.PROPS_CLASSIFICATION_METHOD_NAME]: "",
    [model.PROPS_COLOR_RAMP_GUID]: "",
    [model.PROPS_COLOR_RAMP_NAME]: "",
    [model.PROPS_COMPANY_GUID]: "",
    [model.PROPS_DISPLAY_TYPE_GUID]: "",
    [model.PROPS_DISPLAY_TYPE_NAME]: "",
    [model.PROPS_ERROR_MESSAGE]: null,
    [model.PROPS_IS_ACTIVE]: true,
    [model.PROPS_IS_REC]: false,
    [model.PROPS_MODIFIED_DATE]: "",
    [model.PROPS_NUMBER_OF_CLASSES]: null,
    [model.PROPS_ORG_LEVEL_LIST]: [],
    [model.PROPS_ORG_LEVEL_NAME]: "",
    [model.PROPS_SURFACE_DEFAULTS_GUID]: null,
    [model.PROPS_SYSTEM_ATTRIBUTE_GUID]: "",
    [model.PROPS_SYSTEM_ATTRIBUTE_NAME]: "",
});

export default surfaceDefaultsDefaultRecord;
